import { render } from "./ReferencesList.vue?vue&type=template&id=130ff4dd&scoped=true"
import script from "./ReferencesList.vue?vue&type=script&lang=js"
export * from "./ReferencesList.vue?vue&type=script&lang=js"

import "./ReferencesList.vue?vue&type=style&index=0&id=130ff4dd&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-130ff4dd"]])

export default __exports__